import React from "react"
import { useTheme } from "@chakra-ui/system"
import { THRESHOLD_TOLERANCE } from "../helpers/thresholds"

interface InputProps {
  minThresh: number | undefined
  maxThresh: number | undefined
  val: number | undefined
}

export const useThresholdsColors = ({ minThresh, maxThresh, val }: InputProps): string | undefined => {
  const theme = useTheme()
  // undefined values
  if (minThresh == null || maxThresh == null || val == null) return undefined
  // Calculate the tolerance threshold range as a percentage of the threshold range
  const closeThresholdRange = (maxThresh - minThresh) * THRESHOLD_TOLERANCE
  // below min threshold or above max threshold
  if (val < minThresh || val > maxThresh) return theme.colors.red["600"]
  // equal or close to thresholds
  if (Math.abs(val - minThresh) <= closeThresholdRange || Math.abs(val - maxThresh) <= closeThresholdRange)
    return theme.colors.yellow["500"]
  // okay!
  return undefined
}

export const useThresholdsColorsGetter = () => {
  const theme = useTheme()
  return React.useCallback(
    ({ minThresh, maxThresh, val }: InputProps): string | undefined => {
      // undefined values
      if (minThresh == null || maxThresh == null || val == null) return undefined
      // Calculate the tolerance threshold range as a percentage of the threshold range
      const closeThresholdRange = (maxThresh - minThresh) * THRESHOLD_TOLERANCE
      // below min threshold or above max threshold
      if (val < minThresh || val > maxThresh) return theme.colors.red["600"]
      // equal or close to thresholds
      if (
        Math.abs(val - minThresh) <= closeThresholdRange ||
        Math.abs(val - maxThresh) <= closeThresholdRange
      )
        return theme.colors.yellow["500"]
      // okay!
      return undefined
    },
    [theme],
  )
}
